import { sample } from "effector";
import { $resetPasswordStore, $secondsLeft } from "./store";
import { confirmResetPassword, resetErrors, setInputValue, setSent, tick } from "./events";
import { resetPasswordFx } from "./effects";
import { showErrorToastFx } from "../../../shared/lib/notify/showErrorToast";
import { TResetPasswordInputKey } from "./types";


// Отслеживание setInterval с событием tick (каждую секунду)
// Проверка не вышло ли заданное время в cooldownEnd
sample({
    clock: tick,
  	source: $resetPasswordStore,
  	fn: (state) => {
		if (!state.cooldownEnd) return 0;

		return Math.max(
			0,
			Math.floor((state.cooldownEnd - Date.now()) / 1000)
		);
	},
  	target: $secondsLeft,
});


// Запрос ссылки на востановление пароля при нажатии на кнопку "Восстановить"
sample({
	clock: confirmResetPassword,
	source: {
		passwordStore: $resetPasswordStore,
		secondsLeft: $secondsLeft,
	},
	filter: ({ secondsLeft, passwordStore }) => Boolean(
		secondsLeft === 0 &&
		passwordStore.emailInput.isValid &&
		passwordStore.emailInput.value
	),
	fn: ({ passwordStore }) => {
		return {
			email: passwordStore.emailInput.value
		}
	},
	target: resetPasswordFx,
})


sample({
	clock: setInputValue,
	source: $resetPasswordStore,
	filter: (store, input) => Boolean(
		store.emailInput.errorMessage
		&& input.key === TResetPasswordInputKey.EMAIL_INPUT
	),
	fn: (_, input) => input.key,
	target: resetErrors,
})


// При успешном запросе меняем флаг состояния на отправлено
sample({
	clock: resetPasswordFx.done,
	fn: () => true,
	target: [setSent, tick],
})


// При неудачном запросе показываем уведомление
sample({
	clock: resetPasswordFx.failData,
	fn: (error) => error.message,
	target: showErrorToastFx,
})
